<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">系统设置</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>邀请海报设置</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <div class="page-actions">
      <el-select :value="query.language" @change="handleQueryChange('language', $event)" placeholder="请选择">
        <el-option
                v-for="item in languageList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
      </el-select>
      <create-poster @refresh="refreshList"></create-poster>
    </div>
    <poster-list @refresh="refreshList"></poster-list>
  </el-card>
</div>
</template>

<script>
import './store';
import posterList from './components/list';
import CreatePoster from './components/create';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'posterSetting',
  components: {
    posterList,
    CreatePoster
  },
  computed: {
    ...mapState('posterSetting', ['languageList','query'])
  },
  methods: {
    ...mapActions('posterSetting', ['list']),
    ...mapMutations('posterSetting', ['changeQuery']),
    refreshList() {
      this.list(this.query);
    },
    handleQueryChange(type, value) {
      this.changeQuery({
        ...this.query,
        [type]: value
      });
      this.refreshList();
    }
  },
  created() {
    this.list(this.query);
  }
};
</script>

<style lang="less" scoped>
</style>
